module.exports = require('./$.global');


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/modules/$.path.js
 ** module id = 186
 ** module chunks = 1
 **/